export const BUNDLE_MODIFIER_TITLE = 'Option Group Overrides';
export const BUNDLE_MODIFIER_DESCRIPTION = 'Specify scheme-specific override prices for option groups';
export const CREATE_BUNDLE_OR_MODIFIER_FIRST = 'Create an option group or add modifiers to your products';
export const GO_TO_PRODUCTS = 'Go to Product Library';
export const BUNDLE_MODIFIER_FORM_ID = 'modifier-form';
export const BUNDLE_MODIFIER_UPDATE_MSG = {
  FAILURE: 'Failed to update bundle or modifier',
  SUCCESS: 'Price(s) updated!',
};
